'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.DataRetriever'];
module.exports = angular.module('AVRO.DemandPosting.DemandPostingConfirmationModal', dependencies).controller('DemandPostingConfirmationModalController', require('./controllers/DemandPostingConfirmationModalController')).directive('rmDemandPostingConfirmationModal', require('./directives/DemandPostingConfirmationModalDirective'));